<template>
  <section>
    <validation-observer ref="eventForm" #default="{ invalid }">
      <b-form @submit.prevent="eventForm" v-if="!loading">
        <b-row>
          <b-col cols="12" xl="9" md="8">
            <b-card>
              <b-row>
                <b-col cols="12" md="6">
                  <b-form-group label="نام رویداد" label-for="add-event-name">
                    <validation-provider
                      #default="{ errors }"
                      name="name"
                      vid="name"
                      rules="required"
                    >
                      <b-form-input
                        autocomplete="on"
                        id="add-event-name"
                        v-model="event.title"
                        name="add-event-name"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group
                    label="تاریخ شروع رویداد"
                    label-for="add-event-started_at"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="started_at"
                      vid="started_at"
                      rules="required"
                    >
                      <date-picker
                        v-model="event.started_at"
                        autocomplete="on"
                        id="add-event-started_at"
                        type="datetime"
                        clearable
                        name="add-event-started_at"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <div class="d-flex justify-content-between flex-wrap">
                    <b-form-group
                      label="ظرفیت دوره"
                      label-for="add-event-capacity"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="capacity"
                        vid="capacity"
                        rules="required"
                      >
                        <b-form-input
                          autocomplete="on"
                          id="add-event-capacity"
                          type="number"
                          min="0"
                          v-model="event.capacity"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                    <b-form-group
                      label=" زمان رویداد (ساعت)"
                      label-for="add-event-time"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="time"
                        vid="time"
                        rules="required"
                      >
                        <b-form-input
                          autocomplete="on"
                          id="add-event-time"
                          type="number"
                          min="1"
                          v-model="event.time"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>
                  <b-form-group
                    label="وضعیت"
                    label-for="add-event-status"
                    class="w-100"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="status"
                      vid="status"
                      rules="required"
                    >
                      <select-box
                        v-model="event.status"
                        label="label"
                        select="val"
                        class="w-100"
                        :lists="[
                          { val: '0', label: 'درحال ثبت نام' },
                          { val: '1', label: 'بسته' },
                          { val: '2', label: 'درحال برگزاری' },
                          { val: '3', label: 'پایان یافته' },
                        ]"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <b-form-group label-for="add-event-separate">
                    <b-form-checkbox
                      v-model="event.separate"
                      name="check-separate"
                      switch
                      inline
                      :uncheckedValue="0"
                      :value="1"
                    >
                      قابلیت خرید جدا
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-group
                    label-for="add-event-separate"
                    label="نحوه برگزاری"
                  >
                    <b-form-radio
                      v-model="event.type"
                      name="check-separate"
                      inline
                      :value="0"
                      class="mt-50"
                    >
                      آنلاین
                    </b-form-radio>
                    <b-form-radio
                      v-model="event.type"
                      name="check-separate"
                      inline
                      :value="1"
                      class="mt-50"
                    >
                      حضوری
                    </b-form-radio>
                  </b-form-group>
                  <b-form-group label="لینک" label-for="add-event-link">
                    <validation-provider
                      #default="{ errors }"
                      name="link"
                      vid="link"
                    >
                      <b-form-input
                        autocomplete="on"
                        id="add-event-link"
                        v-model="event.link"
                        name="add-event-link"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group
                    label="قیمت مورد نظر را وارد کنید (تومان)"
                    label-for="add-event-amount"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="amount"
                      vid="amount"
                      rules="required"
                    >
                      <b-form-input
                        autocomplete="on"
                        id="add-event-amount"
                        type="number"
                        min="0"
                        v-model="event.amount"
                        :state="errors.length > 0 ? false : null"
                        class="mb-1"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <b-form-group
                    label-for="add-event-rebate"
                    label="تخفیف (تومان)"
                    class="my-1"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="rebate"
                      vid="rebate"
                      rules="required"
                    >
                      <b-form-input
                        autocomplete="on"
                        id="add-event-rebate"
                        v-model="event.rebate"
                        class="mb-1"
                        type="number"
                        min="0"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <hr class="my-1" />
                  <div class="d-flex my-2 w-100 justify-content-between">
                    <span>قیمت نهایی</span>
                    <span>{{ numberWithCommas(finalAmount) }} تومان</span>
                  </div>
                </b-col>
              </b-row>
              <hr class="my-2" />
              <b-row>
                <b-col cols="12" md="6">
                  <semesters
                    :propSemesters="event.semesters"
                    v-model="event.semesters"
                  />
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-group
                    label="برگزار کنندگان"
                    label-for="add-event-presenters"
                    class="w-100"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="presenters"
                      vid="presenters"
                      class="d-flex justify-content-start align-items-center"
                    >
                      <select-box
                        v-model="event.presenters"
                        multiple
                        class="w-100"
                        label="text"
                        select="id"
                        url="user"
                      >
                      </select-box>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <hr class="my-2" />
              <b-row>
                <b-col cols="12" md="6">
                  <b-form-group
                    label="رویداد شامل به دوره های"
                    label-for="add-event-courses"
                    class="w-100"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="courses"
                      vid="courses"
                      class="d-flex justify-content-start align-items-center"
                    >
                      <select-box
                        v-model="event.courses"
                        multiple
                        label="text"
                        select="id"
                        class="w-100"
                        url="course"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-group
                    label="کاربران"
                    label-for="add-event-users"
                    class="w-100"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="users"
                      vid="users"
                      class="d-flex justify-content-start align-items-center"
                    >
                      <select-box
                        v-model="event.users"
                        multiple
                        label="text"
                        select="id"
                        class="w-100"
                        url="user"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr class="my-2" />

              <b-row>
                <b-col>
                  <b-form-group
                    label="توضیحات"
                    label-for="add-event-description"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="description"
                      vid="description"
                      rules="required"
                    >
                      <editor
                        v-model="event.description"
                        :content="event.description"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col cols="12" md="4" xl="3" class="invoice-actions mt-md-0 mt-2">
            <b-card>
              <b-form-group label="انتخاب بنر" label-for="add-event-events">
                <validation-provider
                  #default="{ errors }"
                  name="events"
                  vid="events"
                  class="d-flex justify-content-start align-items-center w-100"
                >
                  <upload-file
                    class="w-100"
                    @uploadImage="uploadImage"
                    :banner="event.banner"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <hr class="my-2" />
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mb-75"
                block
                :disabled="invalid"
                type="submit"
              >
                {{ $route.params.id ? "ویرایش رویداد" : "ایجاد رویداد" }}
              </b-button>

              <b-button
                :to="{ name: 'events' }"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                block
              >
                برگشت به لیست رویداد ها
              </b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

    <loader :loading="loading" />
  </section>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BBadge,
  BFormCheckbox,
  BFormRadio,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BFormTextarea,
  BImg,
  BCard,
  BCardTitle,
  BFormFile,
  BCardText,
  BModal,
  BListGroupItem,
} from "bootstrap-vue";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import Editor from "@/@core/components/editor/Editor.vue";
import Loader from "@/@core/components/loader/Loader.vue";
import SelectBox from "@/@core/components/select-box/SelectBox.vue";
import UploadFile from "@/@core/components/upload-file/UploadFile.vue";
import draggable from "vuedraggable";
import Semesters from "./Semesters.vue";
export default {
  components: {
    BRow,
    BImg,
    BCol,
    BLink,
    BBadge,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    BFormTextarea,
    BFormFile,
    BModal,
    BCard,
    Loader,
    SelectBox,
    Editor,
    UploadFile,
    BListGroupItem,
    draggable,
    BFormRadio,

    Semesters,
  },
  directives: {
    Ripple,
  },
  computed: {
    finalAmount() {
      let finalAmount = 0;

      finalAmount = Number(this.event.amount) - Number(this.event.rebate);

      return finalAmount > 0 ? String(parseInt(finalAmount)) : "0";
    },
  },
  data() {
    return {
      event: {
        title: "",
        description: "",
        time: "",
        capacity: "",
        amount: "",
        rebate: "",
        separate: 0,
        type: 1,
        started_at: "",
        banner: "",
        presenters: [],
        semesters: [],
        courses: [],
        users: [],
      },
      loading: false,
      required,
    };
  },
  created() {
    if (this.$route.params.id) {
      this.getevent();
    }
  },
  methods: {
    uploadImage(e) {
      this.event.banner = e;
    },
    async getevent() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          `/panel/events/${this.$route.params.id}?includes=roadmaps,presenters,courses,users`
        );
        await Object.keys(data.data).map((item) => {
          item == "active"
            ? (this.event[item] = data.data[item] ? 1 : 0)
            : item == "percentage"
            ? (this.event[item] = data.data[item] ? 1 : 0)
            : item == "separate"
            ? (this.event[item] = data.data[item] ? 1 : 0)
            : item == "status"
            ? (this.event[item] = String(data.data[item]))
            : item == "roadmaps"
            ? (this.event.semesters = data.data[item].roadmaps.map((item) => {
                return {
                  id: item.semester_id,
                  vip: item.vip ? 1 : 0,
                };
              }))
            : item == "users"
            ? (this.event[item] = data.data[item].users)
            : item == "presenters"
            ? (this.event[item] = data.data[item].presenters)
            : item == "courses"
            ? (this.event[item] = data.data[item].courses)
            : (this.event[item] = data.data[item]);
        });
      } catch (err) {}
      this.loading = false;
    },
    eventForm() {
      this.$refs.eventForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          const event = await { ...this.event };
          try {
            this.formData = await new FormData();
            await Object.keys(event).map((item, index) => {
              if (item == "started_at" && event[item]) {
                event[item] = this.toGorgian(event[item]);
              }
              if (item == "banner" && event[item] instanceof File === false) {
                event[item] = "";
              }
              if (item == "semesters" && event[item]) {
                event[item] = event[item].map((item, index) => {
                  return {
                    id: item.id,
                    vip: item.vip,
                    sort: index + 1,
                    type: item.type,
                  };
                });
              }
              this.setFormData(event[item], index, item);
            });

            if (this.$route.params.id) {
              const { data } = await this.$http.post(
                `/panel/events/${this.$route.params.id}`,
                this.formData,
                {
                  params: {
                    _method: "put",
                  },
                }
              );
              await this.getevent();
            } else {
              const { data } = await this.$http.post(
                `/panel/events`,
                this.formData
              );
              this.event = {
                name: "",
                description: "",
                time: "",
                capacity: "",
                amount: "",
                rebate: "",
                separate: 0,
                type: 0,
                available_at: "",
                banner: "",
                presenters: [],
                semesters: [],
                courses: [],
                users: [],
              };
            }
            this.loading = false;
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: `اطلاعات شما با موفقیت ثبت شد.`,
                  icon: "CoffeeIcon",
                  variant: "success",
                },
              },
              { position: "bottom-right" }
            );
          } catch (err) {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
.vpd-input-group {
  .vpd-icon-btn {
    margin-bottom: 0;
  }
  .form-control {
    border-radius: 0;
  }
}
</style>
